var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "birthday_inner" },
    [
      _vm.value.config.category_id
        ? [
            !_vm.parentKey
              ? _c(
                  "div",
                  { staticClass: "tabs" },
                  [
                    _c(
                      "el-tabs",
                      {
                        model: {
                          value: _vm.activeTab,
                          callback: function ($$v) {
                            _vm.activeTab = $$v
                          },
                          expression: "activeTab",
                        },
                      },
                      _vm._l(_vm.tabList, function (item) {
                        return _c("el-tab-pane", {
                          key: item.id,
                          attrs: { label: item.name, name: item.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              {
                class: ["box" + (_vm.value.config.show_type || 1), "clearfix"],
              },
              [
                _vm.value.config.is_open_ad === "1" &&
                Array.isArray(_vm.value.config.ads)
                  ? _vm._l(_vm.value.config.ads, function (item, adIndex) {
                      return _c(
                        "div",
                        { key: adIndex + "_ad", staticClass: "item ad" },
                        [
                          _c("el-image", {
                            staticStyle: { width: "100%" },
                            attrs: { src: item.imageurl },
                          }),
                        ],
                        1
                      )
                    })
                  : _vm._e(),
                _vm._l(_vm.goodsList, function (item, index) {
                  return _c("div", { key: index, staticClass: "item" }, [
                    _c("div", {
                      staticClass: "pic",
                      style: {
                        backgroundImage: "url(" + item.goods_thumb + ")",
                      },
                    }),
                    _c("div", { staticClass: "name" }, [
                      _vm._v(_vm._s(item.goods_name)),
                    ]),
                    _c("div", { staticClass: "brand_name" }, [
                      _vm._v(_vm._s(item.brand_name)),
                    ]),
                    _c("div", { staticClass: "price" }, [
                      _c("span", { staticClass: "num" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("moneyFormat")(item.shop_price)) +
                            " "
                        ),
                      ]),
                      _vm._v(" 点 "),
                    ]),
                  ])
                }),
              ],
              2
            ),
          ]
        : _c("empty", { attrs: { value: _vm.value } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }